<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <GroupForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import GroupForm from '@/components/settings/users/groups/GroupForm'

export default {
  name: 'GroupAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    GroupForm
  }
}
</script>
